import { useMutation } from '@tanstack/react-query';

import { createDiasTask } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { CreateTaskVariablesDias } from '../types';

export default function useCreateTaskDias() {
  return useMutation({
    mutationFn: ({ crmPartyId, documents, ...task }: CreateTaskVariablesDias) =>
      createDiasTask(
        {
          params: {
            path: { dias_id: crmPartyId },
            query: {},
          },
          body: {
            ...task,
            documents: documents?.map((doc) => ({
              ...doc,
              description: task.title,
            })),
            assigned_to:
              typeof task.assignedTo === 'string'
                ? Number(task.assignedTo)
                : (task.assignedTo ?? undefined),
          },
        },
        wgApi,
      ),
  });
}
